import { render, staticRenderFns } from "./SunHeroFooter.vue?vue&type=template&id=0164fc87&scoped=true"
import script from "./SunHeroFooter.vue?vue&type=script&lang=js"
export * from "./SunHeroFooter.vue?vue&type=script&lang=js"
import style0 from "./SunHeroFooter.vue?vue&type=style&index=0&id=0164fc87&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0164fc87",
  null
  
)

export default component.exports